import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AdminService} from "../services/admin.service";
import {AuthenticationService} from "../../auth/services/authentication.service";
import {MatDialog} from "@angular/material/dialog";
import {TranslateService} from "@ngx-translate/core";
import {Subject, takeUntil} from "rxjs";
import {User} from "../../auth/models/User";
import {MatPaginator} from "@angular/material/paginator";
import {TeamDialogComponent} from "./team-dialog/team-dialog.component";
import Swal from "sweetalert2";

@Component({
  selector: 'app-teams',
  templateUrl: './teams.component.html',
  styleUrls: ['./teams.component.scss']
})
export class TeamsComponent implements OnInit, AfterViewInit, OnDestroy {
  teams: any[] = [];
  leagues: any[] = [];
  selectedLeagueId: string = '';
  displayedColumns: string[] = ['name', 'edit', 'delete'];
  currentUser!: User;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  private destroy$ = new Subject<void>();

  constructor(
    private adminService: AdminService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private translate: TranslateService
  ) {
    this.authenticationService.currentUser.pipe(takeUntil(this.destroy$)).subscribe(x => {
      this.currentUser = x!;
    });
  }

  ngOnInit(): void {
    this.loadLeagues();
  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadLeagues(): void {
    this.adminService.getAllLeagues(0, 20).subscribe((data) => {
      this.leagues = data.content;
    });
  }

  loadTeams(leagueId: string): void {
    this.selectedLeagueId = leagueId;
    this.adminService.getAllTeamsFromOneLeague(leagueId).subscribe((data) => {
      this.teams = data.content;
    });
  }

  openEditTeamDialog(team: any): void {
    const dialogRef = this.dialog.open(TeamDialogComponent, {
      width: '500px',
      height: '600px',
      data: {team}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadTeams(this.selectedLeagueId);
      }
    });
  }

  deleteTeam(id: string): void {
    this.translate.get([
      'Are you sure?',
      'You won\'t be able to revert this!',
      'Yes, delete it!',
      'No, cancel!',
      'Deleted',
      'The team has been deleted.',
      'Error',
      'An error occurred while deleting the team.'
    ]).subscribe(translations => {
      Swal.fire({
        title: translations['Are you sure?'],
        text: translations['You won\'t be able to revert this!'],
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: translations['Yes, delete it!'],
        cancelButtonText: translations['No, cancel!']
      }).then((result: any) => {
        if (result.isConfirmed) {
          this.adminService.deleteTeamFromOneLeague(id).subscribe(() => {
            Swal.fire(translations['Deleted'], translations['The team has been deleted.'], 'success');
            this.loadTeams(this.selectedLeagueId);
          }, (error) => {
            Swal.fire(translations['Error'], translations['An error occurred while deleting the team.'], 'error');
          });
        }
      });
    });
  }
}
